<section class="note-activity" aria-label="Note activity">
  @if (loading()) {
    <p role="status">Loading activity…</p>
  }
  @if (error()) {
    <p role="alert">Activity could not load. <button type="button" (click)="reload()">Retry</button></p>
  }
  @if (!loading() && !error() && !rows().length) {
    <p>No activity yet</p>
  }
  @for (row of rows(); track row.uid) {
    <div class="note-activity-row">
      <span>{{ row.text }}</span>
      <time [attr.datetime]="row.atIso">{{ row.at | dateFormat: 'relativeDate' }}</time>
    </div>
  }
  @if (count() > 20) {
    <nav class="note-activity-pages" aria-label="Activity pages">
      <button type="button" [disabled]="page() === 0" (click)="previous()">Previous</button>
      <span>Page {{ page() + 1 }}</span>
      <button type="button" [disabled]="(page() + 1) * 20 >= count()" (click)="next()">Next</button>
    </nav>
  }
</section>
